module.exports = __webpack_public_path__ + "img/small.f4462cfa.jpg";